var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2330_21)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.25 6.77391C23.25 5.75536 22.4244 4.93054 21.4066 4.93054H2.59337C1.57554 4.93054 0.75 5.75536 0.75 6.77391V17.2262C0.75 18.244 1.57554 19.0696 2.59337 19.0696H21.4066C22.4244 19.0696 23.25 18.244 23.25 17.2262V6.77391ZM1.56325 14.8407H7.55893V18.2563H2.59337C2.02446 18.2563 1.56325 17.7951 1.56325 17.2262V14.8407ZM8.37218 18.2563H15.6286V14.8407H8.37218V18.2563ZM16.4418 14.8407H22.4367V17.2262C22.4367 17.7951 21.9755 18.2563 21.4066 18.2563H16.4418V14.8407ZM1.56325 9.97271V14.0274H3.66326V9.97271H1.56325ZM4.47651 9.97271V14.0274H11.5934V9.97271H4.47651ZM12.4066 9.97271V14.0274H19.5242V9.97271H12.4066ZM20.3375 9.97271V14.0274H22.4367V9.97271H20.3375ZM7.55893 5.74379V9.15946H1.56325V6.77391C1.56325 6.205 2.02446 5.74379 2.59337 5.74379H7.55893ZM8.37218 5.74379V9.15946H15.6286V5.74379H8.37218ZM16.4418 5.74379H21.4066C21.9755 5.74379 22.4367 6.205 22.4367 6.77391V9.15946H16.4418V5.74379Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2330_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockTarget);
export default __webpack_public_path__ + "static/media/blockTarget.d4142b31b926d51781bc9d66321c9dd9.svg";
export { ForwardRef as ReactComponent };